"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerSearchFilterOptionLabel = void 0;
const models_1 = require("./models");
const getCustomerSearchFilterOptionLabel = (option) => {
    switch (option) {
        case models_1.CustomerSearchFilterOptions.CARD_ID:
            return 'Card ID';
        case models_1.CustomerSearchFilterOptions.EMAIL:
            return 'Email';
        case models_1.CustomerSearchFilterOptions.NAME:
            return 'Name';
        case models_1.CustomerSearchFilterOptions.PHONE_NUMBER:
        default:
            return 'Phone number';
    }
};
exports.getCustomerSearchFilterOptionLabel = getCustomerSearchFilterOptionLabel;
//# sourceMappingURL=helpers.js.map